/**
 *
 * Asynchronously loads the component for CallbackContainer
 *
 */

import React from 'react'
import loadable from 'utils/loadable'
import { PageLoading } from 'components/Loading'

export default loadable({
  loader: () => import('./index'),
  loading: <PageLoading />
})
